import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { BaseDialog } from 'components'

import { ApprovalCollectDialog, AcceptanceCollect } from './components'

import theme from 'theme'

const VersionAlertDialog = ({
  open,
  setOpen,
  onSubmit,
  collectApproval,
  collectAccepted,
}) => {
  const { control, watch, errors, setError, clearError } = useFormContext()
  const updateType = watch('updateType')
  const [openConfirmation, setOpenConfirmation] = useState(false)

  const handleSubmit = () => {
    if (!updateType) {
      setError(
        'updateType',
        'custom',
        'Selecione pelo menos 1 tipo de atualização',
      )
      return
    }

    clearError('updateType')

    if (updateType === 'new_version' && (collectApproval || collectAccepted)) {
      setOpenConfirmation(true)
    } else {
      onSubmit()
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Controle de versões"
      closeButtonText="Cancelar"
      actionButtonText="Salvar"
      actionButton={handleSubmit}
      justifyActions="flex-end"
      dialogSize="md"
    >
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        py={1}
      >
        <Alert severity="info">
          <Typography>
            Defina como esta atualização será registrada. Escolha gerar{' '}
            <strong>nova versão</strong> para mudanças significativas no
            conteúdo ou estrutura. Para correções pontuais ou ajustes menores,
            selecione salvar como revisão.
          </Typography>
        </Alert>
        <Typography>Como voce deseja registrar essa alteração?</Typography>
        <Typography>Selecione uma opção abaixo:</Typography>
        <Controller
          as={
            <RadioGroup>
              <FormControlLabel
                style={{ marginBottom: theme.spacing(2) }}
                value="revision"
                control={<Radio color="primary" />}
                label={
                  <>
                    <Typography variant="body1">
                      <strong>Salvar como Revisão</strong>
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Use para ajustes menores, como correções de texto ou
                      pequenas atualizações, sem alterar o conteúdo principal.
                    </Typography>
                  </>
                }
              />
              <FormControlLabel
                value="new_version"
                control={<Radio color="primary" />}
                label={
                  <>
                    <Typography variant="body1">
                      <strong>Nova Versão</strong>
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Foram realizadas mudanças relevantes no conteúdo ou na
                      estrutura do documento.
                    </Typography>
                  </>
                }
              />
            </RadioGroup>
          }
          name="updateType"
          control={control}
        />
        {errors?.updateType && (
          <FormHelperText error>{errors.updateType.message}</FormHelperText>
        )}

        {collectApproval && (
          <ApprovalCollectDialog
            open={openConfirmation}
            setOpen={setOpenConfirmation}
            onSubmit={() => {
              setOpenConfirmation(false)
              onSubmit()
            }}
          />
        )}

        {collectAccepted && !collectApproval && (
          <AcceptanceCollect
            open={openConfirmation}
            setOpen={setOpenConfirmation}
            onSubmit={() => {
              setOpenConfirmation(false)
              onSubmit()
            }}
          />
        )}
      </Box>
    </BaseDialog>
  )
}

VersionAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default VersionAlertDialog
